import { render, staticRenderFns } from "./create400Order.vue?vue&type=template&id=f2bab1e0&scoped=true&"
import script from "./create400Order.vue?vue&type=script&lang=js&"
export * from "./create400Order.vue?vue&type=script&lang=js&"
import style0 from "./create400Order.vue?vue&type=style&index=0&id=f2bab1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bab1e0",
  null
  
)

export default component.exports